import React from 'react'
import { css, cx } from '@emotion/css'
import {
  Tooltip,
  TooltipProps
} from '@contrast-security-inc/design-system-popovers'
import { Link } from '@contrast-security-inc/design-system-typography'
import { getApplicationDrilldownRoute } from '../route'
import { AppInstrumentationTooltip } from '../servers-grid/app-instrumentation-tooltip'
import { ProtectApplicationTooltip } from './protect-application-tooltip'

export function ApplicationLinkWithTooltip({
  organizationID,
  applicationID,
  applicationName,
  placement = 'right',
  truncate = false,
  className,
  showAttackStatus = true,
  showLabel = false,
  hasInstrumentationConflict = false
}: {
  organizationID: string
  applicationID: string
  applicationName: string
  placement?: TooltipProps['placement']
  truncate?: boolean
  className?: string
  showAttackStatus?: boolean
  showLabel?: boolean
  hasInstrumentationConflict?: boolean
}) {
  return (
    <div
      data-e2e={`application-link-container-${applicationName}`}
      className={css`
        display: flex;
        align-items: center;
      `}
    >
      <Tooltip
        interactive
        placement={placement}
        body={
          <ProtectApplicationTooltip
            applicationID={applicationID}
            organizationID={organizationID}
            showAttackStatus={showAttackStatus}
            showLabel={showLabel}
          />
        }
      >
        <Link
          color="neutral100"
          className={cx(
            className,
            truncate &&
              css`
                display: block;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                word-wrap: normal;
                padding-bottom: 1px;
              `
          )}
          href={getApplicationDrilldownRoute(organizationID, applicationID)}
        >
          {applicationName}
        </Link>
      </Tooltip>
      {hasInstrumentationConflict && (
        <AppInstrumentationTooltip
          placement="bottom"
          applicationName={applicationName}
        />
      )}
    </div>
  )
}
